import React from 'react';
import { PropTypes } from 'prop-types';
import { useField } from 'formik';

import SelectCollegesSearch from '../../_molecules/SelectCollegesSearch';
import SelectYear from '@molecules/SelectYear';

const FormCollege = ({ nameCollegeName, nameCollegeCode, yearFieldName }) => {
    const [nameField, nameFieldMeta, nameFieldHelpers] = useField(nameCollegeName);
    const [codeField, codeFieldMeta, codeFieldHelpers] = useField(nameCollegeCode);
    const [yearField] = useField(yearFieldName);

    const handleSelect = hit => {
        codeFieldHelpers.setValue(hit.objectID);
        nameFieldHelpers.setValue('');
    };

    return (
        <>
            <SelectCollegesSearch
                name={nameCollegeName}
                label="School"
                onSelect={handleSelect}
                initialRefinement={nameField.value}
            />

            {codeField.value && <SelectYear name={yearFieldName} label="Graduation Year" />}
        </>
    );
};

FormCollege.propTypes = {
    nameCollegeName: PropTypes.string,
    nameCollegeCode: PropTypes.string,
    yearFieldName: PropTypes.string,
};

export default FormCollege;
